"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var theme = require("./theme.scss");
var codemirror = require("codemirror");
var utils_1 = require("../../utils");
/* tslint:disable no-var-requires */
require("codemirror/mode/javascript/javascript");
require("codemirror/mode/htmlmixed/htmlmixed");
require("codemirror/mode/sql/sql");
require("codemirror/addon/selection/active-line");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/lint/lint");
require("codemirror/addon/lint/json-lint");
var codeMirrorOptions = {
    mode: "application/json",
    lint: true,
    gutters: [
        "CodeMirror-lint-markers",
    ],
    indentUnit: 4
};
var CodeEditor = /** @class */ (function (_super) {
    tslib_1.__extends(CodeEditor, _super);
    function CodeEditor(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.focusChanged = function (isFocused) {
            _this.setState({ isFocused: isFocused });
        };
        _this.codemirrorValueChanged = function (doc, change) {
            var _a = _this.props, onChange = _a.onChange, name = _a.name;
            if (_this.props.onChange && change.origin !== "setValue") {
                onChange({
                    name: name,
                    value: doc.getValue()
                });
            }
        };
        _this.setRef = function (ref) {
            _this.textareaNode = ref;
        };
        _this.state = { isFocused: false };
        return _this;
    }
    CodeEditor.prototype.componentDidMount = function () {
        var _a = this.props, value = _a.value, options = _a.options;
        this.codeMirror = codemirror.fromTextArea(this.textareaNode, options || codeMirrorOptions);
        this.codeMirror.on("change", this.codemirrorValueChanged);
        this.codeMirror.on("focus", this.focusChanged.bind(this, true));
        this.codeMirror.on("blur", this.focusChanged.bind(this, false));
        this.codeMirror.setValue(value);
        this.codeMirror.setSize("100%", "100%");
    };
    // public componentDidUpdate(prevProps: ICodeEditorProps) {
    //     if (prevProps.value !== this.props.value && this.codeMirror) {
    //         this.codeMirror.setValue(this.props.value);
    //     }
    // }
    CodeEditor.prototype.componentWillUnmount = function () {
        if (this.codeMirror) {
            this.codeMirror.toTextArea();
        }
    };
    CodeEditor.prototype.refresh = function () {
        if (this.codeMirror) {
            this.codeMirror.setSize("100%", "100%");
            this.codeMirror.refresh();
        }
    };
    CodeEditor.prototype.render = function () {
        var _a, _b;
        var _c = this.props, value = _c.value, name = _c.name, options = _c.options, onChange = _c.onChange, outerClassName = _c.outerClassName, className = _c.className, style = _c.style, label = _c.label, others = tslib_1.__rest(_c, ["value", "name", "options", "onChange", "outerClassName", "className", "style", "label"]);
        var isFocused = this.state.isFocused;
        var classes = classnames(theme.codeMirror, className, "height-max", (_a = {},
            _a[theme.focus] = isFocused,
            _a));
        var labelClasses = classnames(theme.label, (_b = {},
            _b[theme.focus] = isFocused,
            _b));
        return (React.createElement("div", { className: classnames("height-max", outerClassName), style: style },
            label ? React.createElement("div", { className: labelClasses }, label) : null,
            React.createElement("div", tslib_1.__assign({}, others, { className: classes }),
                React.createElement("textarea", { ref: this.setRef, name: name, defaultValue: value }))));
    };
    CodeEditor.defaultProps = {
        onChange: utils_1.noop,
        options: null
    };
    return CodeEditor;
}(React.Component));
exports.default = CodeEditor;
